module.exports = __webpack_public_path__ + "img/abacusvideolock.363215e5.png";